import type { BusinessEventSeverity, BusinessEventType } from "./businessEventTypes";

export const businessEventLabels: Record<BusinessEventType, string> = {
  PASSAGE_CREATED: "Passage créé",
  PASSAGE_TEAM_PROPOSED: "Équipe proposée",
  PASSAGE_TEAM_CONFIRMED: "Affectation équipe confirmée",
  PASSAGE_TEAM_REASSIGNED: "Équipe réaffectée",
  PASSAGE_TEAM_CANCELLED: "Affectation équipe annulée",
  PASSAGE_BLOCKED: "Passage bloqué",
  PASSAGE_STARTED: "Passage démarré",
  PASSAGE_COMPLETED: "Passage terminé",
  PASSAGE_VALIDATED: "Passage validé",
  PASSAGE_REJECTED: "Passage rejeté",
  TOURNEE_CREATED: "Tournée créée",
  TOURNEE_STARTED: "Tournée démarrée",
  TOURNEE_COMPLETED: "Tournée clôturée",
  TOURNEE_CANCELLED: "Tournée annulée",
  PROVISION_INSUFFICIENT: "Provision insuffisante",
  PROVISION_CREDITED: "Provision créditée",
  PROVISION_RESERVED: "Provision réservée",
  PROVISION_CONSUMED: "Provision consommée",
  PROVISION_RELEASED: "Provision libérée",
  PROVISION_BLOCKED: "Provision bloquante",
  STOCK_SHORTAGE: "Stock insuffisant",
  STOCK_CONSUMED: "Stock consommé",
  GPS_CAPTURED: "Position GPS capturée",
  GPS_SUSPECT: "GPS suspect",
  FACTURE_CREATED: "Facture créée",
  FACTURE_AVAILABLE: "Facture disponible",
  FACTURE_PAID: "Facture payée",
  FACTURE_OVERDUE: "Facture en retard",
  FACTURE_CANCELLED: "Facture annulée",
  FACTURE_REFUNDED: "Facture remboursée",
  CLIENT_REQUEST_CREATED: "Demande client créée",
  CLIENT_REQUEST_ACCEPTED: "Demande client acceptée",
  CLIENT_REQUEST_REJECTED: "Demande client rejetée",
  REQUEST_ACCEPTED: "Demande acceptée",
  REQUEST_REJECTED: "Demande rejetée",
  SLA_RISK: "Risque SLA",
  SYSTEM_BUSINESS_RESET: "Réinitialisation métier",
};

export const severityLabels: Record<BusinessEventSeverity, string> = {
  INFO: "Information",
  WARNING: "Attention",
  CRITICAL: "Critique",
};

export function businessEventLabel(type: BusinessEventType): string {
  return businessEventLabels[type] ?? "Événement opérationnel";
}

export function eventIcon(type: BusinessEventType): string {
  if (type.startsWith("PASSAGE_")) return "P";
  if (type.startsWith("TOURNEE_")) return "T";
  if (type.startsWith("GPS_")) return "G";
  if (type.startsWith("FACTURE_")) return "F";
  if (type.startsWith("STOCK_")) return "S";
  if (type.startsWith("PROVISION_")) return "€";
  return "J";
}
